/**
 * Document types (docSeq, entity type 12) of the Credit Proposal's
 * Documents tab, shared by the tab and the Credit Proposal report.
 */

/** The Organogram document type (report Annexure-III (d)). */
export const CREDIT_PROPOSAL_ORGANOGRAM_DOC_SEQ = 43;

/** Document tab: the Organogram plus document types 42, 46 and 50. */
export const CREDIT_PROPOSAL_DOCUMENT_DOC_SEQS: readonly number[] = [
  CREDIT_PROPOSAL_ORGANOGRAM_DOC_SEQ,
  42,
  46,
  50,
];

/** Attachments tab. */
export const CREDIT_PROPOSAL_ATTACHMENT_DOC_SEQS: readonly number[] = [41, 44, 45, 47];

/** Report "Attachments" (below the Organogram): every type except the Organogram, in this order. */
export const CREDIT_PROPOSAL_REPORT_ATTACHMENT_DOC_SEQS: readonly number[] = [41, 42, 44, 45, 46, 47, 50];
